import { DigitalProduct } from "../../../../Redux/digital-product/types";

interface CheckoutCardProps {
  product: DigitalProduct;
  selectedVariation: number;
  onAddToCart: () => void;
  isLoading?: boolean;
}

const CheckoutCard = ({
  product,
  selectedVariation,
  onAddToCart,
  isLoading = false,
}: CheckoutCardProps) => {
  if (!product) return null;

  return (
    <>
      <div className=" card shadow-dark border-2">
        <div className=" p-2 mt-3 px-3">
          {product?.pricingDetails?.offerPrice ? (
            <>
              <h4 className=" text-black fw-normal">
                <sup className="fs-4 fw-light me-0">₹</sup>
                {(() => {
                  const unitPrice = product?.pricingDetails?.unitPrice || 0;
                  const gstAmount = product?.pricingDetails?.gstAmount || 0;
                  const discountAmount =
                    product?.pricingDetails?.offerPrice || 0;

                  const offerPrice = unitPrice + gstAmount - discountAmount;
                  return offerPrice.toFixed(2);
                })()}
              </h4>
            </>
          ) : (
            <>
              <h2 className=" text-black fw-normal">
                <sup className="fs-4 fw-light me-0">₹</sup>
                {(() => {
                  const unitPrice = product?.pricingDetails?.unitPrice || 0;
                  const gstAmount = product?.pricingDetails?.gstAmount || 0;

                  const mrp = unitPrice + gstAmount;
                  return mrp.toFixed(2);
                })()}
              </h2>
            </>
          )}
          {/* Shipping info placeholders or checks can go here */}
          <div className=" mt-3 mb-3">
            <div className=" cursor-pointer">
              <b className=" text-teal fw-normal text-sm">
                <i className="fi fi-bs-marker text-teal me-1 fw-bold text-capitalize"></i>
                {product?.productName?.slice(0, 20)}... <br />
              </b>
            </div>
          </div>
          <div className=" mt-3 lh-1">
            <label className=" form-label">
              Enter pincode to check delivery
            </label>
            <div className=" input-group input-group-outline input-group-md">
              <input
                type="text"
                className=" form-control"
                placeholder="Enter Pincode"
              />
              <span className="btn btn-outline-dark mt-1 input-group-text me-2 p-1">
                Check
              </span>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" mt-0 mb-3 lh-1">
            <h5 className=" text-success fw-normal">
              <span className=" text-success">
                In stock
                {/* Stock details not available in ReferralProduct yet */}
              </span>
            </h5>
            <div className=" mt-3 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-sm text-black fw-normal">Ships from</b>
              </div>
              <div className=" text-start w-100">
                <b className=" text-sm text-teal fw-normal text-capitalize">
                  {product?.sellerDetails?.region}
                </b>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-black text-sm fw-normal">Sold by</b>
              </div>
              <div className=" text-start w-100">
                {/* <a href={`/SellerDetail/${product?._id}`}> */}
                <a href="#">
                  <b className="  text-teal text-sm fw-normal text-capitalize">
                    {product?.brand}
                  </b>
                </a>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-black text-sm fw-normal">Payment</b>
              </div>
              <div className=" text-start w-100">
                <b className=" text-teal text-sm fw-normal text-capitalize">
                  Secure Transaction
                </b>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className="  text-black text-sm fw-normal">Gift Options</b>
              </div>
              <div className=" text-start w-100">
                <b className="text-teal text-sm fw-normal">
                  {product?.pricingDetails?.salarShoppingVoucher
                    ? "Available"
                    : "Not Available"}
                </b>
              </div>
            </div>
          </div>

          <div className=" mb-2">
            <button
              className=" btn btn-md btn-yellow w-100"
              onClick={onAddToCart}
              disabled={isLoading}
            >
              {isLoading ? "Adding..." : "Add to Cart"}
            </button>
          </div>
          <div className=" mb-3">
            <button className=" btn btn-md btn-dark w-100">
              Add to wishlist
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutCard;
